import { CatalogProps } from '../../utils/enhanced-ecommerce';
import { MATERIAL_CARD_IMPRESSION_BUFFER_LIMIT } from './material-card-impression.constants';
import qualityEvents from './quality-events';
import qualityEventsHelpers, {
    ExtractMaterialType,
    PageContext,
    ViewMaterialCardItem,
    capturePageContext
} from './quality-events.helpers';

type MaterialCardImpressionsByInternalPath = Record<string, ViewMaterialCardItem[]>;

const materialCardImpressionHelper = (function () {
    let cache: Record<string, boolean> = {};
    let toBeTracked: MaterialCardImpressionsByInternalPath = {};
    let bufferedCount = 0;
    // Captured on the first buffered impression — flush may run after navigation.
    let capturedContext: PageContext | null = null;
    // AB TEST - MCP-1559 (remove on either accept or reject)
    let isEnabled = false;

    const flush = () => {
        if (Object.keys(toBeTracked).length === 0) {
            return;
        }

        qualityEvents.materialCard.view(toBeTracked, capturedContext ?? capturePageContext());
        toBeTracked = {};
        bufferedCount = 0;
        capturedContext = null;
    };

    const track = (item: Material, params: CatalogProps) => {
        const internalPath = params.internalPath;

        // AB TEST - MCP-1559 (remove on either accept or reject)
        if (!isEnabled || !internalPath) {
            return;
        }

        const cacheKey = `${internalPath}_${item.id}`;

        if (!cache[cacheKey]) {
            const { item_id, position } = qualityEventsHelpers.extractMaterialsData(
                item,
                params
            ) as ExtractMaterialType;

            if (!capturedContext) {
                capturedContext = capturePageContext();
            }

            if (!toBeTracked[internalPath]) {
                toBeTracked[internalPath] = [];
            }

            toBeTracked[internalPath].push({
                material_id: item_id,
                position: typeof params.itemIndex === 'number' ? position : null
            });
            cache[cacheKey] = true;
            bufferedCount += 1;

            if (bufferedCount >= MATERIAL_CARD_IMPRESSION_BUFFER_LIMIT) {
                flush();
            }
        }
    };

    const reset = () => {
        cache = {};
    };

    // AB TEST - MCP-1559 (remove on either accept or reject)
    const setEnabled = (value: boolean) => {
        isEnabled = value;
    };

    return { track, flush, reset, setEnabled };
})();

export default materialCardImpressionHelper;
